import BigNumber from 'bignumber.js';

export const ZERO = new BigNumber(0);

export const ONE = new BigNumber(1);

export const HUNDRED = new BigNumber(100);

export const currentEnv = import.meta.env.VITE_ENV;

export const IS_LOCAL =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '[::1]' ||
  import.meta.env.DEV;

export const EXPLORER_LINK =
  currentEnv === 'prod'
    ? 'https://explorer.iota.org'
    : 'https://explorer.rebased.iota.org';

export const EPOCH_START_TIMESTAMP =
  currentEnv === 'prod' ? 1746517145 : 1742757572;

export const EPOCH_DURATION = 86400; // 1 day in seconds

export const DECIMALS = 1e9;

export const DECIMALS_RATIO = 1e18;

export const DEFAULT_SHORT_DECIMAL_PLACES = 2;

export const MIN_STAKE_VALUE = new BigNumber(1);

export const IOTA_DEFAULT_DIVIDER = new BigNumber(1_000_000_000);

export const DOCS_URL = 'https://docs.swirlstake.com';

export const X_URL = 'https://x.com/swirlstake';

export const DISCORD_URL = 'https://discord.gg/x3fFAUmbud';
